import React, { useState } from 'react';
import { ContextMenu, ContextMenuButton } from '../../ContextMenu';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import IForm from '../../../../types/IForm';
import ModalDialog from '../../../../components/organisms/ModalDialog/ModalDialog';
import { UserMembershipCreateForm } from '../forms/UserMembershipCreateForm';
import { UserMembershipDeleteForm } from '../forms/UserMembershipDeleteForm';
import { useRefreshBlock } from '../../../BlockFetcher';
import { useDelayed } from '../../../../hooks/useDelayed';

type UserMembershipContextMenu = { role: string; editForm: IForm; deleteForm?: IForm };

export function UserMemberShipContextMenu({ role, editForm, deleteForm }: UserMembershipContextMenu) {
  const { t } = useSonTranslation('UserMemberships');

  const [openForm, setOpenForm] = useState<{ form: IForm; type: 'delete' | 'edit' }>();
  const closeModal = () => setOpenForm(undefined);
  const { refresh } = useRefreshBlock();
  const delayedCloseModal = useDelayed(closeModal);

  const onSuccess = () => {
    refresh();
    delayedCloseModal();
  };

  const editDetails = t('edit.details', { role });
  const deleteDetails = t('delete.details', { role });

  const getActiveForm = () => {
    switch (openForm?.type) {
      case 'edit':
        return (
          <ModalDialog closeModal={closeModal} headline={editDetails}>
            <UserMembershipCreateForm form={openForm.form} onSuccess={onSuccess} />
          </ModalDialog>
        );
      case 'delete':
        return (
          <ModalDialog closeModal={closeModal} headline={deleteDetails}>
            <UserMembershipDeleteForm form={openForm.form} onSuccess={onSuccess} />
          </ModalDialog>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <ContextMenu tooltipText={t('manageRole', { role })}>
        <ContextMenuButton onClick={() => setOpenForm({ form: editForm, type: 'edit' })}>
          {editDetails}
        </ContextMenuButton>
        {deleteForm && (
          <ContextMenuButton onClick={() => setOpenForm({ form: deleteForm, type: 'delete' })}>
            {deleteDetails}
          </ContextMenuButton>
        )}
      </ContextMenu>
      {getActiveForm()}
    </>
  );
}
